import { EWeekDay } from 'core/model/enums/distributor.enum';

export const WeekDayAbbreviation: Record<EWeekDay, string> = {
  [EWeekDay.MONDAY]: 'Lun',
  [EWeekDay.TUESDAY]: 'Mar',
  [EWeekDay.WEDNESDAY]: 'Mie',
  [EWeekDay.THURSDAY]: 'Jue',
  [EWeekDay.FRIDAY]: 'Vie',
  [EWeekDay.SATURDAY]: 'Sab',
  [EWeekDay.SUNDAY]: 'Dom',
};

export const WeekDayFullName: Record<EWeekDay, string> = {
  [EWeekDay.MONDAY]: 'Lunes',
  [EWeekDay.TUESDAY]: 'Martes',
  [EWeekDay.WEDNESDAY]: 'Miércoles',
  [EWeekDay.THURSDAY]: 'Jueves',
  [EWeekDay.FRIDAY]: 'Viernes',
  [EWeekDay.SATURDAY]: 'Sábado',
  [EWeekDay.SUNDAY]: 'Domingo',
};

export const DaysOrder: Array<EWeekDay> = [
  EWeekDay.MONDAY,
  EWeekDay.TUESDAY,
  EWeekDay.WEDNESDAY,
  EWeekDay.THURSDAY,
  EWeekDay.FRIDAY,
  EWeekDay.SATURDAY,
  EWeekDay.SUNDAY,
];

/**
 * Specific error codes for branches customer exclusion validation.
 */
export const BRANCHES_SPECIFIC_ERROR_CODE_LIST = ['SFE1906'] as const;

export const BRANCHES_MAP_SPECIFIC_ERROR_CODE_LIST = new Map<
  (typeof BRANCHES_SPECIFIC_ERROR_CODE_LIST)[number],
  'file'
>([['SFE1906', 'file']]);
